import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Maze from './Maze'
import { Subscribe } from './components'
import { COLORS } from './constants'
import ReactGA from 'react-ga'

import './App.css'

function getRoulette () {
  return Math.floor(Math.random() * (5))
}

class App extends Component {
  state = {
    start: false,
    iteration: 0,
    variation: getRoulette(),
    titleUp: false
  }

  componentDidMount () {
    ReactGA.pageview('vscaper.com')
  }

  images = [
    'images/wall-blue.png',
    'images/wall-cyan.png',
    'images/wall-red.png',
    'images/wall-green.png',
    'images/wall-grey.png',
    'images/wall-violet.png'
  ]

  startTransitionOnImageLoad () {
    this.setState({
      start: true,
      started: true
    })
  }

  onTransitionEnd () {
    this.setState({
      start: false,
      variation: getRoulette(),
      iteration: this.state.iteration + 1
    }, () => {
      setTimeout(() => this.setState({ start: true }), 1)
    })
  }

  toggleTitleClass () {
    this.setState({
      titleUp: !this.state.titleUp
    })
  }

  render () {
    return (
      <div className='App'>
        <Helmet>
          <meta name='viewport' content='width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, minimal-ui' />
          <meta name='apple-mobile-web-app-capable' content='yes' />
          <title>vscaper - we amaze</title>
          <meta property='og:image' content='./images/wall-blue.png' />
        </Helmet>
        <header className={`App-header ${this.state.titleUp && 'App-header--up'}`}>
          <h1 className='App-title1'>Vscaper</h1>
          <h2 className='App-title2'>we Amaze</h2>
        </header>
        <div className='App'>
          <Maze
            start={this.state.start}
            started={this.state.started}
            variation={this.state.variation}
            iteration={this.state.iteration}
            startTransitionOnImageLoad={() => this.startTransitionOnImageLoad()}
            onTransitionEnd={() => { this.onTransitionEnd() }}
             />
          <footer className='footer'>
            <div>
              <a href='mailto:info@vscaper.com'>Contact</a>
            </div>
            <span className='copyright'>© Vscaper Ltd. - 2018</span>
            <Subscribe color={COLORS[this.state.variation]} toggleTitle={() => this.toggleTitleClass()} />
          </footer>
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js